// 新版多幣種畫布頁面翻譯 - 繁體中文
export default {
  // 對話框標題
  dialogs: {
    note: "備註",
    batchNote: "批量備註",
    separateNote: "分開備註",
    unifiedNote: "統一備註",
    addLabel: "添加標籤",
    editLabel: "修改標籤",
    deleteLabel: "刪除標籤",
    addMonitor: "添加監控",
    saveInfo: "保存資訊",
    modifyInfo: "修改資訊",
  },

  // 表單標籤
  forms: {
    label: "標籤",
    notePlaceholder: "請輸入備註內容",
    selectPlaceholder: "請選擇",
    inputPlaceholder: "請輸入內容",
  },

  // 成功提示信息
  success: {
    monitorAdded: "地址監控添加成功",
    caseDataAdded: "地址加入數據看板添加成功",
    caseDataAnalyzing: "案件數據分析中，請耐心等待",
    verifyResultReady: "已有驗證結果",
  },

  // 按鈕文字
  buttons: {
    cancel: "取 消",
    confirm: "確 定",
    closeDialog: "關閉彈窗",
    viewMonitor: "查看監控",
    viewCaseData: "查看案件數據",
    viewVerifyResult: "查看驗證結果",
    addNew: "新增",
  },

  // 加載狀態
  loading: {
    text: "拼命加載中",
  },

  // 左側菜單
  leftMenu: {
    details: "詳情",
    filter: "篩選",
    survey: "調證",
    history: "歷史",
    canvasFilter: "畫布篩選",
  },

  // 提示信息
  tooltip: {
    unsavedCanvas:
      "請先保存並關聯案件(未命名畫布無法自動保存)；完成後可解鎖更多深度分析能力。",
  },

  // 通知消息
  notifications: {
    tooManyNodes: {
      title: "提示",
      message: "畫布節點過多，可能會影響畫布效率，建議新建畫布",
    },
    aggregateEdgeWarning: {
      title: "警告",
      message: "操作聚合邊不支持展開",
    },
    aggregateNodeWarning: {
      title: "提示",
      message: "聚合點不支持該操作！",
    },
  },
};
